
export default {
    props: {
    },

    data : function(){
            return {
                backgroundColor: '',
                dividerStyle: '',
            };
        },

    created: function(){
        const style = this.styleMe('vanilla', 'StoreFront', 'button');
        this.backgroundColor = (style && style[1] && style[1]['background-color']) ? style[1]['background-color'] : '#cccccc';
        this.dividerStyle = `2px solid ${this.backgroundColor}`;
    }
}
